import styled from '@emotion/styled'
import { css } from '@emotion/react'
import cn from 'classnames'
import { isEmpty } from 'util/objects'
import { Icon, Tooltip } from 'shared/ui'

import { getDisplayLabel } from 'util/recipientLabel'

const Recipient = styled('div')`
  box-shadow: 0 0 0 1px ${props => props.theme.color.monochrome.medium};
  border-radius: 2rem;
  padding-left: ${props => props.theme.spacing['6']};
  padding-right: ${props => props.theme.spacing['6']};
  width: 100%;
  height: 32px;
  display: flex;
  align-items: center;
  line-height: 32px;
`

const Truncated = styled('div')`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

const iconStyle = () => theme => css`
  margin-left: ${theme.spacing['3']};
`

export default function RemovableRecipient({
  className,
  allUsers,
  user,
  onClick,
  children,
}) {
  if (!user || isEmpty(user)) return null

  return (
    <Tooltip
      tooltip={user.email}
      position={'top'}
      css={css`
        max-width: 90%;
        margin-right: 4px;
      `}
    >
      <Recipient className={cn('grui', className)}>
        <Truncated className="grui mr-auto">
          {getDisplayLabel(user, allUsers)}
        </Truncated>
        <Icon
          name="close"
          size="xxsmall"
          onClick={onClick}
          css={iconStyle}
          color="color.monochrome.dark"
          hoverColor="blue"
        />
      </Recipient>
      {children}
    </Tooltip>
  )
}
